import { useDispatch, useSelector, useStore } from 'react-redux'

import type { RootState, AppDispatch } from './store'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

export const useAppSelector = useSelector.withTypes<RootState>()

// Para leer el estado en el momento en que se ejecuta un callback asíncrono, no el snapshot del
// render. Va por react-redux a propósito: importar el módulo del store desde un hook crea un ciclo
// (store -> rootReducers -> services -> hook) que deja los slices en undefined.
export const useAppStore = useStore.withTypes<ReturnType<typeof useStore<RootState>>>()
